// src/pages/StripeRedirectBridge.jsx
import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../../provider";
import * as api from '../../../Auth/auth'
import axios from "axios";
import ButtonsMainGoTo from "../../../components/Button/ButtonMainGoTo";
import {
  Container,
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";
import { API_URL } from "../../../constants";
import { useTranslation } from "../../../language";



export default function StripeRedirectBridge() {

  const { t } = useTranslation();
  const { handleLogout } = useAuth();

  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const navigate = useNavigate();
  const hasRun = useRef(false);

  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);

  const [statusMessage, setStatusMessage] = useState(null);

 useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const handleRedirect = async () => {
      // Validate session ID
      if (!sessionId || !sessionId.startsWith('cs_')) {
        setError(t('onb_srb_invalid_session'));
        setStatus("error");
        return;
      }

      try {
        setStatus("processing");

        const res = await axios.get(`${API_URL}/stripe/chained-redirect/`, {
          params: { session_id: sessionId },
          timeout: 15000,  // 30 seconds — gives live mode enough headroom
        });

        if (res.data.redirect_url) {
          window.location.href = res.data.redirect_url; // go to Stripe add-on checkout
        } else if (res.data.next_url) {
          window.location.href = res.data.next_url; // go to success page directly
        }
      } catch (err) {
        console.error("Chained redirect failed:", err);
        
        let errorMsg = t('onb_srb_generic_error');

        if (err.code === 'ECONNABORTED') {
          errorMsg = t('onb_srb_timeout');
        } else if (err.response?.status === 404) {
          errorMsg = t('onb_srb_session_not_found');
        } else if (err.response?.status === 400) {
          errorMsg = err.response.data?.error || t('onb_srb_invalid_session_short');
        } else if (err.response?.data?.error) {
          errorMsg = err.response.data.error;
        }
        
        setError(errorMsg);
        setStatus("error");
      }
    };

    handleRedirect();
  }, [sessionId, navigate]);

useEffect(() => {
  const messages = [
    { delay: 3000,  text: t('onb_srb_confirming') },
    { delay: 8000,  text: t('onb_srb_almost') },
    { delay: 14000, text: t('onb_srb_long_wait') },
  ];

  const timers = messages.map(({ delay, text }) =>
    setTimeout(() => setStatusMessage(text), delay)
  );

  return () => timers.forEach(clearTimeout);
}, []);

const handleLogoutapi = async () => {
      let response = await api.logout()
      await handleLogout(response);
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 3,
          backgroundColor: "background.paper",
        }}
      >
        {(status === "loading" || status === "processing" ? (
          <>
          <Typography variant="h5" gutterBottom>
            {t('onb_srb_finalizing')}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            {statusMessage ?? t('onb_srb_verifying')}
          </Typography>
          <CircularProgress color="primary" />
        </>
        ) : error ? (
          <>
            <Typography variant="h5" color="error" gutterBottom>
              ⚠️ {t('onb_srb_redirect_failed')}
            </Typography>
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
            
            <ButtonsMainGoTo name={t('onb_srb_return')} to="/Login" onClick={handleLogoutapi}/>
        
        
          </>
        ) : null)}
      </Box>
    </Container>
  );
}
